export const sensorVertex = `
varying vec3 vNormal;
varying float vViewZ;
void main() {
    vec4 mvPos = modelViewMatrix * vec4(position, 1.0);
    vViewZ = -mvPos.z;
    vNormal = normalize(normalMatrix * normal);
    gl_Position = projectionMatrix * mvPos;
}
`;

export default sensorVertex;
